import { HvlQueryModel } from '@hvlng/framework-bff/core';
import { JsonObject, JsonProperty } from 'json2typescript';
import { EmptyControl, MaxLength } from '@hvlng/framework-bff/core';

@JsonObject('KovanHrCodeTextQueryModel')
export class CodeTextQueryModel extends HvlQueryModel {
    @MaxLength(25)
    @JsonProperty('code', String, true)
    code?: string = null;

    @EmptyControl()
    @JsonProperty('longText', String, true)
    longText?: string = null;

    @EmptyControl()
    @JsonProperty('shortText', String, true)
    shortText?: string = null;
}
